import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from "react-redux";

//*Common
import Login from './Pages/auth/Login'
import Forgot from './Pages/auth/Forgot'
import Recover from './Pages/auth/Recover'
import PrivateRoute from './PrivateRoute'
import Home from './Pages/Home';
import Forbidden from './Pages/Forbidden';
import GenericNotFound from './GenericNotFound'
//*Purchase
import PurchaseDashboard from '../purchase/PurchaseDashboard'
import PurchaseListByStatus from '../purchase/PurchaseListByStatus'
import PurchaseOrderDetail from '../purchase/PurchaseOrderDetail'
//*Maintenance
import MaintenanceDashboard from '../maintenance/MaintenanceDashboard'
import MaintenanceListByStatus from '../maintenance/MaintenanceListByStatus'
import MaintenanceUploadEvidence from '../maintenance/MaintenanceUploadEvidence'
import MaintenanceUploadComplement from '../maintenance/MaintenanceUploadComplement'
import MaintenanceUploadInvoice from '../maintenance/MaintenanceUploadInvoice'
//*Indirect
import IndirectDashboard from '../indirect/IndirectDashboard'
import IndirectListByStatus from '../indirect/IndirectListByStatus'
import IndirectUploadInvoice from '../indirect/IndirectUploadInvoice'
import IndirectUploadComplement from '../indirect/IndirectUploadComplement'
import IndirectAssingSupplier from '../indirect/IndirectAssingSupplier'
//*Collateral
import CollateralDashboard from '../collateral/CollateralDashboard'
import CollateralListByStatus from '../collateral/CollateralListByStatus';
import CollateralDetailsOnTime from '../collateral/collateralDetails/CollateralDetailsOnTime'
import CollateralDetailsOutOfTime from '../collateral/collateralDetails/CollateralDetailsOutOfTime'
import CollateralDetailsOnTramit from '../collateral/collateralDetails/CollateralDetailsOnTramit';
import CollateralDetailsComprobation from '../collateral/collateralDetails/CollateralDetailsComprobation'
import CollateralDetailsPaymentOnDelay from '../collateral/collateralDetails/CollateralDetailsPaymentOnDelay'
import CollateralDetailsFinalization from '../collateral/collateralDetails/CollateralDetailsFinalization';
//*Telematics
import TelematicsDashboard from '../telematics/TelematicsDashboard'
import TelematicsListByStatus from '../telematics/TelematicsListByStatus'
import InstallationOrderDetails from '../telematics/InstallationOrderDetails'
import TelematicsServiceDetails from '../telematics/TelematicsServiceDetails'
import TelematicsUploadEvidence from '../telematics/TelematicsUploadEvidence'
import TelematicsTechnicians from '../telematics/TelematicsTechnicians'
import TelematicsAsignTechnician from '../telematics/TelematicsAsignTechnician'
import TelematicsInvoiceReception from '../telematics/TelematicsInvoiceReception';
import TelematicsTechnicianDashboard from '../telematics/TelematicsTechnicianDashboard';
import TelematicsUnasignTechnician from '../telematics/TelematicsUnasignTechnician';
//*Other Transactions
import OtherTransactionsDashboard from '../othertransactions/OtherTransactionsDashboard'
import OrdersList from '../othertransactions/OrdersList'
import OrderDetail from '../othertransactions/orderDetails/OrderDetail'

const Routes = (props) => {

  return (
    <Switch>
      <Route path='/login' component={Login} exact />
      <Route path='/forgot' component={Forgot} exact />
      <Route path='/recover' component={Recover} exact />
      <Route path='/register' component={Recover} exact />
      <PrivateRoute path='/' component={Home} exact props={props} />
      <PrivateRoute path='/forbidden' component={Forbidden} exact props={props} />

      <PrivateRoute path='/purchase/:supplierId' component={PurchaseDashboard} exact props={props} />
      <PrivateRoute path='/purchase/listByStatus/:status&:supplierId' component={PurchaseListByStatus} exact props={props} />
      <PrivateRoute path='/purchase/orderDetail/:orderId' component={PurchaseOrderDetail} exact props={props} />

      <PrivateRoute path='/maintenance/:branchOfficeId' component={MaintenanceDashboard} exact props={props} />
      <PrivateRoute path='/maintenance/listByStatus/:status&:branchOfficeId' component={MaintenanceListByStatus} exact props={props} />
      <PrivateRoute path='/maintenance/UploadEvidence/:orderId' component={MaintenanceUploadEvidence} exact props={props} />
      <PrivateRoute path='/maintenance/UploadInvoice/:orderId' component={MaintenanceUploadInvoice} exact props={props} />
      <PrivateRoute path='/maintenance/UploadComplement/:orderId' component={MaintenanceUploadComplement} exact props={props} />

      <PrivateRoute path='/indirect/:branchOfficeId' component={IndirectDashboard} exact props={props} />
      <PrivateRoute path='/indirect/listByStatus/:status&:branchOfficeId' component={IndirectListByStatus} exact props={props} />
      <PrivateRoute path='/indirect/UploadInvoice/:orderId' component={IndirectUploadInvoice} exact props={props} />
      <PrivateRoute path='/indirect/UploadComplement/:orderId' component={IndirectUploadComplement} exact props={props} />
      <PrivateRoute path='/indirect/AssingSupplier/:orderId' component={IndirectAssingSupplier} exact props={props} />

      <PrivateRoute path='/collateral/:branchOfficeId' component={CollateralDashboard} exact props={props} />
      <PrivateRoute path='/collateral/listByStatus/:stage&:branchOfficeId' component={CollateralListByStatus} exact props={props} />
      <PrivateRoute path='/collateral/WorkOrderDetailsOnTime/:branchOfficeId&:woid' component={CollateralDetailsOnTime} exact props={props} />
      <PrivateRoute path='/collateral/WorkOrderDetailsOutOfTime/:branchOfficeId&:woid' component={CollateralDetailsOutOfTime} exact props={props} />
      <PrivateRoute path='/collateral/WorkOrderDetailsOnTramit/:branchOfficeId&:woid' component={CollateralDetailsOnTramit} exact props={props} /> 
      <PrivateRoute path='/collateral/WorkOrderDetailsComprobation/:branchOfficeId&:woid' component={CollateralDetailsComprobation} exact props={props} />
      <PrivateRoute path='/collateral/WorkOrderDetailsPaymentOnDelay/:branchOfficeId&:woid' component={CollateralDetailsPaymentOnDelay} exact props={props} />
      <PrivateRoute path='/collateral/WorkOrderDetailsFinalization/:branchOfficeId&:woid' component={CollateralDetailsFinalization} exact props={props} />

      <PrivateRoute path='/telematics/:branchOfficeId' component={TelematicsDashboard} exact props={props} />
      <PrivateRoute path='/telematics/listByStatus/:status&:branchOfficeId' component={TelematicsListByStatus} exact props={props} />
      <PrivateRoute path='/telematics/InstalationDetails/:branchOfficeId&:instalationId&:tabNumber' component={InstallationOrderDetails} exact props={props} />
      <PrivateRoute path='/telematics/AsignTechnician/:branchOfficeId&:instalationId' component={TelematicsAsignTechnician} exact props={props} />
      <PrivateRoute path='/telematics/UnasignTechnician/:instalationId' component={TelematicsUnasignTechnician} exact props={props} />
      <PrivateRoute path='/telematics/InvoiceReception/:branchOfficeId&:instalationId' component={TelematicsInvoiceReception} exact props={props} />
      <PrivateRoute path='/telematics/ServiceDetails/:branchOfficeId&:installationOrderId&:serviceId' component={TelematicsServiceDetails} exact props={props} />
      <PrivateRoute path='/telematics/UploadEvidence/:branchOfficeId&:serviceId&:typeService&:instalationId' component={TelematicsUploadEvidence} exact props={props} />
      <PrivateRoute path='/telematics/TechnicianList/:branchOfficeId' component={TelematicsTechnicians} exact props={props} />
      <PrivateRoute path='/telematics/InstallationOrders/My' component={TelematicsTechnicianDashboard} exact props={props} />

      <PrivateRoute path='/othertransactions/:branchOfficeId' component={OtherTransactionsDashboard} exact props={props} />
      <PrivateRoute path='/othertransactions/:quadrant/listOrders/:branchOfficeId' component={OrdersList} exact props={props} />
      <PrivateRoute path='/othertransactions/:quadrant/listOrders/orderDetail/:branchOfficeId&:pymtOrdId' component={OrderDetail} exact props={props} />
      
      <Route component={GenericNotFound} />
    </Switch>
  )
}

const mapStateToProps = state => ({
  isUserAuthenticated: state.LoginReducer.isAuthenticated
})

const mapActionToProps = {
}

export default connect(mapStateToProps, mapActionToProps)(Routes)
